<template>
    <v-container class="d-flex flex-column pa-0">
        <v-row dense>
            <template v-if="isEventForMe">
                <v-col v-if="canChangePayments" cols="12">
                    <v-btn outlined color="primary" class="action-button" block @click="$emit('set-payment')">
                        <v-icon left small>mdi-currency-usd</v-icon>
                        Opłata
                    </v-btn>
                </v-col>
                <v-col v-if="canOpenTask" cols="12">
                    <v-btn color="success" class="action-button" block @click="$emit('start-dispatcher-task')">
                        <v-icon left small>mdi-progress-star</v-icon>
                        Rozpocznij obsługę
                    </v-btn>
                </v-col>
                <v-col v-if="canCloseTask" cols="12" lg="6">
                    <v-btn color="success" class="action-button" block @click="$emit('close-all-tasks')">
                        <v-icon left small>mdi-progress-check</v-icon>
                        Zakończ obsługę
                    </v-btn>
                </v-col>
                <v-col v-if="canCloseTask" cols="12" lg="6">
                    <v-btn color="orange" class="action-button white--text" block @click="$emit('cancel-task')">
                        <v-icon left small>mdi-account-cancel-outline</v-icon>
                        Anuluj
                    </v-btn>
                </v-col>
            </template>
            <template v-else>
                <v-col cols="12" v-if="canCloseTask">
                    <v-btn color="info" class="action-button" block @click="$emit('assign-to-me')">
                        <v-icon left small>mdi-clipboard-account</v-icon>
                        Przejmij obsługę
                    </v-btn>
                </v-col>
            </template>
            <!-- <v-col v-if="canCloseTask && isEventForMe" cols="12" lg="6">
                <v-btn color="info" class="action-button" block outlined @click="$emit('assign-to-other')">
                    <v-icon left small>mdi-clipboard-account</v-icon>
                    Przekaż obsługę
                </v-btn>
            </v-col>
            <v-col v-if="canCloseTask && isEventForMe" cols="12" lg="6">
                <v-btn color="info" class="action-button" block outlined @click="$emit('release-from-me')">
                    <v-icon left small>mdi-clipboard-account-outline</v-icon>
                    Zrezygnuj z obsługi
                </v-btn>
            </v-col> -->
            <!-- <v-col cols="12">
                <v-divider class="my-2" />
            </v-col>
            <v-col cols="12" lg="6">
                <v-btn outlined v-if="canEditEvent" color="success" class="action-button" block
                    @click="$emit('edit-event')">
                    <v-icon left small>mdi-pencil</v-icon>
                    Edycja
                </v-btn>
            </v-col>
            <v-col cols="12" lg="6">
                <v-btn outlined v-if="canDeleteEvent" color="error" class="action-button" block
                    @click="$emit('delete-event')">
                    <v-icon left small>mdi-delete</v-icon>
                    Usuń
                </v-btn>
            </v-col> -->
        </v-row>
        <v-divider class="my-4" />
        <v-row class="">
            <v-col cols="3">
                <tab-btn :visible="canCloseTask" text="Wyślij patrol" icon="mdi-car-outline"
                    @click="$emit('send-patrol')" />
            </v-col>
            <v-col cols="3">
                <tab-btn :visible="canCloseTask" text="Osoba w obiekcie" icon="mdi-account-check-outline"
                    @click="$emit('found-users')" />
            </v-col>
            <v-col cols="3">
                <tab-btn :visible="canCloseTask" text="Powiadom" icon="mdi-account-alert-outline"
                    @click="$emit('notify-users')" />
            </v-col>
            <v-col cols="3" v-if="canCloseTask">
                <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                        <tab-btn text="Notatka" icon="mdi-note-plus-outline" v-bind="attrs" v-on="on" />
                    </template>
                    <v-list dense>
                        <v-subheader>Nie działa<br>do analizy później</v-subheader>
                        <v-list-item @click="$emit('add-note', 'skip-alarms')">
                            <v-list-item-icon>
                                <v-icon small>mdi-alarm-off</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>Pomijaj alarmy</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item @click="$emit('add-note', 'skip-similar-alarms')">
                            <v-list-item-icon>
                                <v-icon small>mdi-alarm-multiple</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>Pomijaj podobne alarmy</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item @click="$emit('add-note', 'skip-sensor-alarms')">
                            <v-list-item-icon>
                                <v-icon small>mdi-alarm-panel-outline</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>Pomijaj alarmy z tej czujki</v-list-item-title>
                            </v-list-item-content>
                            <v-subheader>Przy monitorowaniu nr. strefy, wejścia itp.</v-subheader>
                        </v-list-item>
                        <v-divider />
                        <v-list-item @click="$emit('add-note', 'service-work')">
                            <v-list-item-icon>
                                <v-icon small>mdi-tools</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>Prace serwisowe</v-list-item-title>
                            </v-list-item-content>
                            <v-subheader>Serwisant nie włączył trybu serwisowego - trzeba zrobić to za
                                niego</v-subheader>
                        </v-list-item>
                        <v-list-item @click="$emit('add-note', 'skip-failures')">
                            <v-list-item-icon>
                                <v-icon small>mdi-alert-octagon-outline</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>Pomijaj awarie</v-list-item-title>
                            </v-list-item-content>
                            <v-subheader>Coś się popsuło na obiekcie, lub awaria zasilania w regionie</v-subheader>
                        </v-list-item>
                        <v-divider />
                        <v-list-item @click="$emit('add-note', 'general-note')">
                            <v-list-item-icon>
                                <v-icon small>mdi-note-text-outline</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>Notatka ogólna</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item @click="$emit('add-note', 'skip-region-alarms')">
                            <v-list-item-icon>
                                <v-icon small>mdi-map-marker-off-outline</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>Pomijaj alarmy w regionie</v-list-item-title>
                            </v-list-item-content>
                            <v-subheader>Np. ulica, dzielnia, promień - okrąg na mapie</v-subheader>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-col>
            <!-- <v-col cols="3">
                <tab-btn text="Zapis do pliku" icon="mdi-cloud-download-outline"
                    @click="$emit('download')" />
            </v-col> -->
        </v-row>
    </v-container>
</template>

<script>
export default {
    name: 'EventActionButtons',
    props: {
        canCloseTask: {
            type: Boolean,
            default: false
        },
        canOpenTask: {
            type: Boolean,
            default: false
        },
        canEditEvent: {
            type: Boolean,
            default: false
        },
        canDeleteEvent: {
            type: Boolean,
            default: false
        },
        canChangePayments: {
            type: Boolean,
            default: false
        },
        isEventForMe: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style scoped>
.action-button {
    margin: 0px 0 !important;
    text-transform: none !important;
}

.action-button:hover {
    transform: translateY(-1px);
}

.action-button .v-icon {
    margin-right: 8px;
}
</style>
